import type { DemoMetadata } from "@/registry/types";

export const metadata: DemoMetadata = {
  id: "performance",
  name: "performance.name",
  description: "performance.description",
  longDescription: "performance.longDescription",
  category: "shared.categories.performance",
  tags: "performance.tags",
  featured: false,
  status: "coming-soon",
  architecture: "performance.architecture",
  technologies: "performance.technologies",
  concepts: "performance.concepts",
  i18nNamespace: "performance",
};
